module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Gowallet_image_8.ca38d278.jpg";